const MODULE_NAME = 'NotificationsModule';

export const UPDATE_JOB_WATCHERS = `${MODULE_NAME}/UPDATE_JOB_WATCHERS`;
export const SEND_JOB_NOTIFICATION = `${MODULE_NAME}/SEND_JOB_NOTIFICATION`;
export const GET_JOB_NOTIFICATION_LOG = `${MODULE_NAME}/GET_JOB_NOTIFICATION_LOG`;
export const GET_NOTIFICATION_TEMPLATES = `${MODULE_NAME}/GET_NOTIFICATION_TEMPLATES`;
export const GET_NOTIFICATION_EVENT_SETTINGS = `${MODULE_NAME}/GET_NOTIFICATION_EVENT_SETTINGS`;
export const UPDATE_NOTIFICATION_EVENT_SETTING = `${MODULE_NAME}/UPDATE_NOTIFICATION_EVENT_SETTING`;
export const CREATE_NOTIFICATION_TEMPLATE = `${MODULE_NAME}/CREATE_NOTIFICATION_TEMPLATE`;
export const UPDATE_NOTIFICATION_TEMPLATE = `${MODULE_NAME}/UPDATE_NOTIFICATION_TEMPLATE`;
export const ARCHIVE_NOTIFICATION_TEMPLATE = `${MODULE_NAME}/ARCHIVE_NOTIFICATION_TEMPLATE`;
